import { render, staticRenderFns } from "./TvSchedule.vue?vue&type=template&id=01f44646&scoped=true"
import script from "./TvSchedule.vue?vue&type=script&lang=js"
export * from "./TvSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f44646",
  null
  
)

export default component.exports